<template>
    <v-dialog v-model="dialog" width="400px">
        <template v-slot:activator="{ on }">
            <v-btn v-on="on" small icon 
                class="mx-2"
                color="secondary">
                <v-tooltip bottom color="primary">
                        <template v-slot:activator="{ on }">
                            <v-icon small v-on="on">mdi-delete</v-icon>
                        </template>
                        <span>delete</span>
                    </v-tooltip>
            </v-btn>
        </template>
        <v-card v-if="!loading">
            <v-card-title class="subtitle-2 pt-6">
                Do you really want to delete the segment {{ this.segment.name }}?
            </v-card-title>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text 
                    class="text-capitalize"
                    @click="closeDialog">
                    No
                </v-btn>
                <v-btn color="error" text class="text-capitalize" 
                    :disabled="Boolean(error)"
                    @click="deleteSegment">
                    Yes</v-btn>
            </v-card-actions>
        </v-card>
        <div v-else class="text-xs-center">
            <loader></loader>
        </div>
    </v-dialog>
</template>

<script>
import Loader from '../../../layouts/Loader.vue'

export default {
    props: ['segment'],
    data() {
        return {
            dialog: false,
            error: '',
        }
    },
    computed: {
        loading() {
            return this.$store.getters.loading
        },
    },
    methods: {
        closeDialog() {
            this.dialog = false;
        },
        async deleteSegment() {

            /*console.log(this.segment);*/  
            if (this.segment && this.segment.id) {
                
                const payload = {
                    id: this.segment.id,
                    segmentId: this.segment.segmentId
                };
                 
               try {
                    await this.$store.dispatch('deleteSegment', payload);
                }
                catch (error) {
                    console.log(error.message)
                }
            }
        }
    },
    components: { Loader }
}
</script>